import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27da79ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
import P2PNormal from '@shared/assets/img/speedup/p2p-normal.png';
import P2PVip from '@shared/assets/img/speedup/p2p-vip.png';
import SuperClose from '@shared/assets/img/speedup/super-closed.png';
import SuperStarted from '@shared/assets/img/speedup/super-started.png';
import VipClosed from '@shared/assets/img/speedup/vip-closed.png';
import VipStarted from '@shared/assets/img/speedup/vip-started.png';
import VipStopped from '@shared/assets/img/speedup/vip-stopped.png';
import { openPopSpeedupDetail } from '@remote/utils/dialog';
import { computed } from 'vue';
import { stat } from '@remote/utils/stat';
export default /*#__PURE__*/_defineComponent({
  __name: 'SpeedUp',
  props: {
    speedUp: {
      type: Object,
      default: () => ({})
    },
    isVIP: {
      type: Boolean,
      default: false
    },
    isSVIP: {
      type: Boolean,
      default: false
    },
    // 是否为试用中
    isInTry: {
      type: Boolean,
      default: false
    },
    task: {
      type: Object,
      required: true
    },
    gcid: {
      type: String,
      default: ''
    },
    infoHash: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    /**
     * vip，super任意一个状态为starting，则状态没有获取完全，此时暂不展示组件。
     * */
    const isComponentShow = computed(() => {
      return !(props.speedUp.vip === 'starting' || props.speedUp.super === 'starting');
    });
    const checkDetail = () => {
      stat({
        action: 'downloading_speed_icon_click',
        data: {
          vip: props.speedUp.vip,
          super: props.speedUp.super,
          gcid: props.gcid,
          info_hash: props.infoHash,
          url: props.url
        }
      });
      openPopSpeedupDetail({
        task: props.task,
        speedUp: props.speedUp,
        isSVIP: props.isSVIP,
        isVIP: props.isVIP,
        isInTry: props.isInTry,
        gcid: props.gcid,
        infoHash: props.infoHash,
        url: props.url
      });
    };
    const icon = computed(() => {
      // 非会员只有一种状态。
      if (!props.isVIP && !props.isInTry) {
        return {
          p2p: P2PNormal,
          vip: VipClosed,
          super: SuperClose
        };
      }
      return {
        p2p: P2PVip,
        vip: props.speedUp.vip === 'stopped' ? VipStopped : props.speedUp.vip === 'started' ? VipStarted : VipClosed,
        super: props.speedUp.super === 'started' ? SuperStarted : SuperClose
      };
    });
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("span", {
        class: "speed-up",
        onClick: checkDetail
      }, [_createElementVNode("img", {
        class: "icon-img",
        src: icon.value.p2p,
        alt: "P2P加速状态",
        draggable: "false"
      }, null, 8, _hoisted_1), _createElementVNode("img", {
        class: "icon-img",
        src: icon.value.super,
        alt: "超级通道加速状态",
        draggable: "false"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        class: "icon-img",
        src: icon.value.vip,
        alt: "会员加速状态",
        draggable: "false"
      }, null, 8, _hoisted_3)], 512)), [[_vShow, isComponentShow.value]]);
    };
  }
});